import { ReactElement } from "react";
import { ITextWithIconProps } from "./types";
import { Flex, Text, Tooltip, useMantineTheme } from "@mantine/core";

export default function TextWithIcon({
  icon,
  text,
  tooltip,
}: ITextWithIconProps): ReactElement {
  const theme = useMantineTheme();

  return (
    <Tooltip
      arrowPosition="center"
      arrowSize={theme.spacing.xs}
      closeDelay={300}
      color="dark"
      disabled={!tooltip}
      label={tooltip}
      position="bottom"
      withArrow
      withinPortal
    >
      <Flex align="center" direction="row">
        {icon}

        <Text fz="sm" ml="xs">
          {text}
        </Text>
      </Flex>
    </Tooltip>
  );
}
